import { createContext, useContext, useState } from "react";

export const STRINGS = {
  it: {
    navApps: "./app", navHow: "./come-funziona", navDashboard: "Area Personale", navAdmin: "Admin", navLogin: "ACCEDI_",
    heroBadge: "PORTALE OPEN · ZERO ADS · 100% GRATIS",
    h1l1: "Le tue idee.", h1l2a: "Il nostro ", h1l2b: "codice", h1l3: "App per tutti.",
    heroP1: "GHOSTCODE trasforma le idee della community in app e giochi per iOS e Android. ",
    heroP2: "Gratuiti, senza pubblicità, per sempre.",
    heroP3: " Sostenuti solo da donazioni libere dentro le app.",
    terminal: '$ ghostcode --build "la_tua_idea"',
    ctaIdea: "PROPONI UN'IDEA", ctaExplore: "ESPLORA LE APP",
    statIdeas: "Idee inviate", statApps: "App pubblicate", statDonations: "Donazioni €",
    marquee: ["APP GRATUITE", "ZERO PUBBLICITÀ", "iOS + ANDROID", "OPEN COMMUNITY", "DONAZIONI LIBERE", "AGGIORNAMENTI CONTINUI"],
    howTag: "// COME FUNZIONA", howT1: "Dalla tua idea allo store, ", howTNeon: "in 4 fasi",
    steps: [
      { title: "Invia l'idea", desc: "Registrati e descrivi l'app o il gioco che vorresti esistesse. Nessun vincolo, nessun costo." },
      { title: "Revisione & sviluppo", desc: "Il team GHOSTCODE valuta le idee e sviluppa le migliori. Segui lo stato nella tua area personale." },
      { title: "Pubblicazione gratuita", desc: "L'app arriva su App Store e Google Play. Gratis per tutti, senza pubblicità né tracker." },
      { title: "Donazioni libere", desc: "Chi usa le app può donare direttamente in-app. Le donazioni coprono sviluppo e aggiornamenti." },
    ],
    showTag: "// SHOWCASE", showT1: "App ", showTNeon: "pubblicate",
    filters: { tutte: "Tutte", giochi: "Giochi", produttivita: "Produttività", utility: "Utility" },
    donated: "donati", details: "Dettagli",
    donTag: "// ECOSISTEMA DONAZIONI", donT1: "Niente pubblicità.", donTNeon: "Solo generosità.",
    donP1: "Ogni app GHOSTCODE è gratuita al 100% e senza banner, tracker o acquisti obbligatori. Chi ama un'app può fare una ",
    donP2: "donazione libera direttamente al suo interno",
    donP3: ": è quello che finanzia lo sviluppo e gli aggiornamenti continui.",
    donFeatures: [
      { title: "Zero ads, zero tracker", desc: "Nessun dato venduto, nessuna interruzione. Mai." },
      { title: "Donazioni in-app volontarie", desc: "Da €1 in su, solo se vuoi. Ogni euro va allo sviluppo." },
      { title: "Aggiornamenti continui", desc: "Le donazioni mantengono le app vive, sicure e aggiornate." },
    ],
    ctaT1: "Hai un'idea che merita di ", ctaTNeon: "esistere", ctaT2: "?",
    ctaP: "Registrati, invia la tua idea e seguila fino allo store. È gratis, ovviamente.",
    ctaBtn: "INIZIA ORA",
    footer: "© 2026 GHOSTCODE — ghostcode.it · app gratuite, per sempre. Fatto con codice e donazioni.",
    footerPrivacy: "Privacy Policy", footerDisclaimer: "Disclaimer",
    authLogin: "ACCEDI", authRegister: "REGISTRATI",
    phName: "nome_utente", phEmail: "nome@ghostcode.it", phPassword: "password (min 6 caratteri)",
    btnLogin: "ACCEDI_", btnRegister: "CREA ACCOUNT_", processing: "ELABORAZIONE...",
    authFooter: "SESSIONE PROTETTA · JWT · ZERO TRACKER",
    toastLogin: "Bentornato su GHOSTCODE", toastRegister: "Account creato. Benvenuto!",
    dashTag: "// AREA PERSONALE", hello: "Ciao, ", dashSub: "Invia nuove idee e segui il loro percorso fino allo store.",
    formTitle: "Proponi una nuova idea", phIdeaTitle: "Titolo dell'app (es. GhostFit)",
    phIdeaDesc: "Descrivi la tua idea: cosa fa, per chi, perché dovrebbe esistere... (min 10 caratteri)",
    btnSendIdea: "INVIA IDEA_", sending: "INVIO...", yourIdeas: "Le tue idee",
    emptyIdeas: "nessuna_idea_trovata", emptySub: "Invia la tua prima idea con il form qui accanto.",
    toastIdea: "Idea inviata! La troverai qui sotto con lo stato aggiornato.",
    statuses: { inviata: "Inviata", in_revisione: "In revisione", in_sviluppo: "In sviluppo", pubblicata: "Pubblicata" },
    cats: { giochi: "Giochi", produttivita: "Produttività", utility: "Utility" },
    adminTag: "// PANNELLO ADMIN", adminTitle: "Gestione idee", adminSub: "Fai avanzare lo stato delle idee. L'ideatore riceve una email ad ogni cambio di stato.",
    advance: "AVANZA STATO_", noIdeas: "Nessuna idea inviata dagli utenti.",
    toastStatus: "Stato aggiornato", emailSent: "Email inviata all'ideatore.", emailFail: "Email non inviata.",
    by: "di", maxStatus: "Pubblicata — stato finale",
    phNote: "Messaggio per l'ideatore (opzionale, incluso nell'email)", noteFromTeam: "Nota dal team",
    back: "Torna alle app", about: "Informazioni", downloadsLbl: "download", donatedLbl: "donati dagli utenti",
    ratingLbl: "valutazione", freeBadge: "GRATIS · ZERO ADS · ZERO TRACKER", getIos: "Scarica per iOS", getAndroid: "Scarica per Android",
    platformsLbl: "Piattaforme", versionLbl: "Versione",
    donateNote: "Puoi sostenere questa app con una donazione libera direttamente al suo interno.",
    notFound: "App non trovata.",
  },
  en: {
    navApps: "./apps", navHow: "./how-it-works", navDashboard: "My Dashboard", navAdmin: "Admin", navLogin: "SIGN IN_",
    heroBadge: "OPEN PORTAL · ZERO ADS · 100% FREE",
    h1l1: "Your ideas.", h1l2a: "Our ", h1l2b: "code", h1l3: "Apps for everyone.",
    heroP1: "GHOSTCODE turns community ideas into apps and games for iOS and Android. ",
    heroP2: "Free, ad-free, forever.",
    heroP3: " Sustained only by voluntary donations inside the apps.",
    terminal: '$ ghostcode --build "your_idea"',
    ctaIdea: "SUBMIT AN IDEA", ctaExplore: "EXPLORE APPS",
    statIdeas: "Ideas submitted", statApps: "Apps published", statDonations: "Donations €",
    marquee: ["FREE APPS", "ZERO ADS", "iOS + ANDROID", "OPEN COMMUNITY", "FREE DONATIONS", "CONTINUOUS UPDATES"],
    howTag: "// HOW IT WORKS", howT1: "From your idea to the store, ", howTNeon: "in 4 steps",
    steps: [
      { title: "Submit your idea", desc: "Sign up and describe the app or game you wish existed. No strings attached, no cost." },
      { title: "Review & development", desc: "The GHOSTCODE team reviews ideas and builds the best ones. Track the status in your dashboard." },
      { title: "Free publication", desc: "The app lands on the App Store and Google Play. Free for everyone, no ads, no trackers." },
      { title: "Voluntary donations", desc: "App users can donate directly in-app. Donations cover development and updates." },
    ],
    showTag: "// SHOWCASE", showT1: "Published ", showTNeon: "apps",
    filters: { tutte: "All", giochi: "Games", produttivita: "Productivity", utility: "Utility" },
    donated: "donated", details: "Details",
    donTag: "// DONATION ECOSYSTEM", donT1: "No advertising.", donTNeon: "Just generosity.",
    donP1: "Every GHOSTCODE app is 100% free with no banners, trackers or forced purchases. If you love an app you can make a ",
    donP2: "voluntary donation right inside it",
    donP3: ": that's what funds development and continuous updates.",
    donFeatures: [
      { title: "Zero ads, zero trackers", desc: "No data sold, no interruptions. Ever." },
      { title: "Voluntary in-app donations", desc: "From €1 up, only if you want. Every euro goes to development." },
      { title: "Continuous updates", desc: "Donations keep the apps alive, secure and up to date." },
    ],
    ctaT1: "Got an idea that deserves to ", ctaTNeon: "exist", ctaT2: "?",
    ctaP: "Sign up, submit your idea and follow it all the way to the store. It's free, of course.",
    ctaBtn: "START NOW",
    footer: "© 2026 GHOSTCODE — ghostcode.it · free apps, forever. Made with code and donations.",
    footerPrivacy: "Privacy Policy", footerDisclaimer: "Disclaimer",
    authLogin: "SIGN IN", authRegister: "SIGN UP",
    phName: "username", phEmail: "name@ghostcode.it", phPassword: "password (min 6 characters)",
    btnLogin: "SIGN IN_", btnRegister: "CREATE ACCOUNT_", processing: "PROCESSING...",
    authFooter: "SECURE SESSION · JWT · ZERO TRACKERS",
    toastLogin: "Welcome back to GHOSTCODE", toastRegister: "Account created. Welcome!",
    dashTag: "// MY DASHBOARD", hello: "Hi, ", dashSub: "Submit new ideas and follow their journey to the store.",
    formTitle: "Submit a new idea", phIdeaTitle: "App title (e.g. GhostFit)",
    phIdeaDesc: "Describe your idea: what it does, who it's for, why it should exist... (min 10 characters)",
    btnSendIdea: "SUBMIT IDEA_", sending: "SENDING...", yourIdeas: "Your ideas",
    emptyIdeas: "no_ideas_found", emptySub: "Submit your first idea using the form next to this.",
    toastIdea: "Idea submitted! You'll find it below with its updated status.",
    statuses: { inviata: "Submitted", in_revisione: "In review", in_sviluppo: "In development", pubblicata: "Published" },
    cats: { giochi: "Games", produttivita: "Productivity", utility: "Utility" },
    adminTag: "// ADMIN PANEL", adminTitle: "Idea management", adminSub: "Advance the status of ideas. The creator receives an email on every status change.",
    advance: "ADVANCE STATUS_", noIdeas: "No ideas submitted by users yet.",
    toastStatus: "Status updated", emailSent: "Email sent to the creator.", emailFail: "Email not sent.",
    by: "by", maxStatus: "Published — final status",
    phNote: "Message for the creator (optional, included in the email)", noteFromTeam: "Note from the team",
    back: "Back to apps", about: "About", downloadsLbl: "downloads", donatedLbl: "donated by users",
    ratingLbl: "rating", freeBadge: "FREE · ZERO ADS · ZERO TRACKERS", getIos: "Get it for iOS", getAndroid: "Get it for Android",
    platformsLbl: "Platforms", versionLbl: "Version",
    donateNote: "You can support this app with a voluntary donation directly inside it.",
    notFound: "App not found.",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("gc_lang") || "it");
  const toggle = () => {
    const next = lang === "it" ? "en" : "it";
    localStorage.setItem("gc_lang", next);
    setLang(next);
  };
  return <LangContext.Provider value={{ lang, toggle, t: STRINGS[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
